<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="题目分类用途：">
            <el-select v-model="query.purposeTypes" placeholder="请选择" clearable size="small">
              <el-option label="类型考试" :value="1"></el-option>
              <el-option label="类型练习" :value="2"></el-option>
              <el-option label="课程考试" :value="3"></el-option>
              <el-option label="闯关考试" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="试卷分类名称：">
            <el-input v-model="query.name" placeholder="请输入试卷分类名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.state" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新建分类</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="题目分类用途" prop="name" align="center" >
          <template slot-scope="{row}">
            <span v-if="row.purposeTypes">
              <el-tag v-for="(type, index) in getPurposeTypes(row.purposeTypes)" :key="index" size="small" style="margin-right: 5px;">
                {{type}}
              </el-tag>
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="试卷分类名称" prop="name" align="center" />
        <el-table-column label="创建时间" prop="createdTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.state" :active-value="1" :inactive-value="0" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作人" prop="operatedBy" align="center" />
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <!-- <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <topicClass-add ref="topicClassAdd" @created="doQueryList({})" :menuOptions="list" />
  </div>
</template>

<script>
import topicClassAdd from './add'
import courseTopicClassificationApi from '@/api/course/courseTopicClassification'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
    topicClassAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        name: undefined,
        purposeTypes: undefined,
        state: undefined,
      },
      selectItems: [],
      activeName: '1',
      purposeTypeArr: ['', '类型考试', '类型练习', '课程考试', '闯关考试']
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    /**
     * 将逗号隔开的字符串转换为标签数组
     */
    getPurposeTypes(purposeTypes) {
      if (!purposeTypes) return []
      const types = purposeTypes.split(',').map(item => item.trim()).filter(item => item)
      return types.map(type => {
        const index = parseInt(type)
        return this.purposeTypeArr[index] || ''
      }).filter(item => item)
    },
    handleFilter(){
      this.query = {}
      this.doQueryList({ pageNo: 1,pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return courseTopicClassificationApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => courseTopicClassificationApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择角色')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => courseTopicClassificationApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      courseTopicClassificationApi.update(row).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.topicClassAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row, type) {
      this.$emit('handleShow', row, type)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.topicClassAdd.handleUpdate(row)
    }
  }
}
</script>
